module.exports = __webpack_public_path__ + "static/media/icon_nav_invoice.b91603d6.svg";